import Vue from '../../lib/Vue';
import shop from '../../api/shop'
import * as types from '../mutation-types'

// initial state
// shape: [{ id, quantity }]
const STORAGE_KEY = 'roupoo-cart'

const state = {
  added: JSON.parse(window.localStorage.getItem(STORAGE_KEY) || '[]'),
  checkoutStatus: null
}

// getters
const getters = {
  cartCheckoutStatus: state => state.checkoutStatus,
}


// actions
const actions = {
  checkout ({ commit, state }, { forCustomer, order}) {
    return new Promise( (resolve, reject) => {
      const savedCartItems = Array.prototype.slice.call([...state.added])
      // commit(types.CHECKOUT_REQUEST)
      shop.buyProducts(forCustomer, order,
        (response) => {
          // commit(types.CHECKOUT_SUCCESS)
          resolve(response);
        },
        () => {
          commit(types.CHECKOUT_FAILURE, { savedCartItems })
          reject('error')
        }
      )
    });
  },

  clearCart ({commit}) {
    commit(types.CLEAR_CART);
  },

  checkoutSuccess({commit}) {
    commit(types.CHECKOUT_SUCCESS)
  },
}

// mutations
const mutations = {
  [types.ALTER_UNIT] (state, {id, unit2 }) {
    const record = state.added.find(p => p._id === id)
    if (record) {
      Vue.set(record, 'unit2', unit2)
    }
  },
  [types.ALTER_SPEC] (state, {id, spec}) {
    const record = state.added.find(p => p._id === id)
    if (record) {
      record.spec = spec
    }
  },
  [types.ADD_TO_CART] (state, { id, name, spec, unit, unit2 }) {
    const record = state.added.find(p => p._id === id)
    if (!record) {
      state.added.push({
        _id: id,
        name,
        spec,
        quantity: 1,
        unit,
        unit2,
      })
    } else {
      if(record.quantity < 999){
        record.quantity++
        record.spec = spec
        record.unit2 = unit2
      }
    }
  },

  [types.CLEAR_CART] (state) {
    state.added = [];
  },

  [types.REMOVE_FROME_CART] (state, { id, spec }) {
    const record = state.added.find(p => p._id === id)
    if(!record || record.quantity == 0) return;
    record.quantity--;
    record.spec = spec;
    if(record.quantity == 0){
      state.added.splice(state.added.indexOf(record),1)
    }
  },

  [types.ALTER_NUM] (state, { id, num, spec }) {
    const record = state.added.find(p => p._id === id)
    if(!record || record.quantity == 0) return;
    record.quantity = num;
    record.spec = spec;
    if(record.quantity <= 0){
      state.added.splice(state.added.indexOf(record),1)
    }
  },

  [types.CHECKOUT_REQUEST] (state) {
    // clear cart
  },

  [types.CHECKOUT_SUCCESS] (state) {
    state.checkoutStatus = 'successful'
    state.added = []
    state.checkoutStatus = null
  },

  [types.CHECKOUT_FAILURE] (state, { savedCartItems }) {
    // rollback to the cart saved before sending the request
    state.added = savedCartItems
    state.checkoutStatus = 'failed'
  },


}

export default {
  state,
  getters,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/cart.js